import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { IS_AUTHENTICATED_URL } from "../features/UrlHelper";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [userEmail, setUserEmail] = useState(null);
  const [userId, setUserId] = useState(null);
  const [discount, setDiscount] = useState(0);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const login = (admin = false, email = null, id = null, discount = 0) => {
    setIsLoggedIn(true);
    setIsAdmin(admin);
    setUserEmail(email);
    setUserId(id);
    setDiscount(discount);
  };
  const logout = () => {
    setIsLoggedIn(false);
    setIsAdmin(false);
    setUserEmail(null);
    setUserId(null);
    setDiscount(0);
    window.localStorage.removeItem("authToken");
  };

  async function checkAuthStatus() {
    await axios
      .get(IS_AUTHENTICATED_URL, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setIsLoggedIn(true);
        setIsAdmin(response.data.admin);
        setUserEmail(response.data.email ?? null);
        setUserId(response.data.id ?? null);
        setDiscount(response.data.discount ?? 0);
      })
      .catch(() => {
        setIsLoggedIn(false);
        setIsAdmin(false);
        setUserEmail(null);
        setUserId(null);
        setDiscount(0);
      })
      .finally(() => {
        setAuthLoading(false);
      });
  }

  const [registerOpen, setRegisterOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const openRegisterModal = () => setRegisterOpen(true);
  const openLoginModal = () => setLoginOpen(true);
  const closeAuthModals = () => {
    setRegisterOpen(false);
    setLoginOpen(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        isAdmin,
        authLoading,
        userEmail,
        userId,
        discount,
        setDiscount,
        login,
        logout,
        registerOpen,
        setRegisterOpen,
        loginOpen,
        setLoginOpen,
        openRegisterModal,
        openLoginModal,
        closeAuthModals,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}
